const softFeaturesBlock = () => {
    const el = $('.js-soft-item'),
        picture = $('.js-soft-image picture'),
        image = picture.find('img'),
        source = picture.find('source');

    el.each((index, item) => {
        $(item).on('click', () => {
            let newSrc = $(item).data('image');
            if (image.attr("src") !== newSrc) {
                picture.fadeTo(800, 0.30, function () {
                    image.attr("src", newSrc);
                    source.attr("srcset", newSrc);
                }).fadeTo(600, 1);
            }
            if (!$(item).hasClass('active')) {
                el.each((i, block) => $(block).removeClass('active'));
                $(item).addClass('active');
            }
        })
    })
}
export default softFeaturesBlock;